import React from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { mapIdentityOptions } from "@common/components/helpers/options/identityFormOptions";
import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";

/**
 * Identity Form component.
 *
 * @typedef {Object} Props
 * @property {function} register - Register function passed from react-hook-form
 * @property {object} errors - errors object passed from react-hook-form
 *
 * @param {Props} props
 * @returns {JSX.Element} The rendered react component.
 */
export default function IdentityForm() {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const { identityFormOptions, loadingIdentityOptions, optionalName } =
    useSelector((store) => IdentityFormModalAction.getStatePath(store));


  const options = mapIdentityOptions(identityFormOptions, optionalName);

  return (
    <div className="m-1">
      {options.map((item) => {
        return (
          <item.component
            {...item}
            key={item.name}
            register={register}
            control={control}
            error={errors[item.name]}
            loading={loadingIdentityOptions}
          />
        );
      })}
    </div>
  );
}
